import { workshopsVars } from '../../../constants/vuexVariables'

const state = {
  [workshopsVars.WORKSHOPS]: []
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/workshops/state.js